import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Informes';

export interface InformeParteSinAdjuntos {
    nombre: string;
    email: string;
	idDN: string;
	direccionNegocio: string;
    partesSinAdjuntos: number;
}

export interface InformeHorasPorConcepto{
	idConcepto: number;
	concepto: string;
	nHoras: number;
}

export interface InformeHorasPorSociedad{
	sociedad: string;
	nHorasControl: number;
	nHorasUtilidad: number;
	nHorasTotal: number;
	porcControl: number;
	porcUtilidad: number;
}

export interface InformeHorasPorFuncion{
	funcion: string;
	nHoras: number;
}

export interface InformeHorasPorSubFuncion{
	idSubFuncion: number;
	subFuncion: string;
	nHoras: number;
}

export interface InformeHorasControlUtilidad{
	horasControl: number;
	horasUtilidad: number;
}

export interface InformeHorasPorDNSG{
	idDN: string;
	direccionNegocio: string;
	nHorasControl: number;
	nHorasUtilidad: number;
	nHorasTotal: number;
}

export interface InformeHorasPorProyecto{
	proyecto: string;
	nHorasControl: number;
	nHorasUtilidad: number;
	nHorasTotal: number;
}

export interface InformeHorasPorPais{
	codPais: string;
	pais: string;
	nHoras: number;
}

export interface InformePersonasMasCincuentaPorc{
	nombre: string;
    email: string;
    idDN: string;
    direccionNegocio: string;
	año: number;
    mes: number;
    horasMes: number;
    horasEstimadas: number;
    horasFaltan: number;
}

export interface InformePersonasMenosCincuentaPorc{
	nombre: string;
    email: string;
    idDN: string;
    direccionNegocio: string;
	año: number;
    mes: number;
    horasMes: number;
    horasEstimadas: number;
    dedicacionTerceros: number;
}

export class InformesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarPartesSinAdjuntos(filtro:any): AxiosPromise<InformeParteSinAdjuntos[]> {
		return this.cliente.post(filtro,`/SinAdjuntos`);
	}
	
	ListarHorasPorConceptoFacturacion(filtro:any): AxiosPromise<InformeHorasPorConcepto[]> {
		return this.cliente.post(filtro,`/HorasPorConcepto`);
	}

	ListarHorasPorSociedad(filtro:any): AxiosPromise<InformeHorasPorSociedad[]> {
		return this.cliente.post(filtro,`/HorasPorSociedad`);
	}

	ListarHorasPorFuncion(filtro:any): AxiosPromise<InformeHorasPorFuncion[]> {
		return this.cliente.post(filtro,`/HorasPorFuncion`);
	}

	ListarHorasPorSubFuncion(filtro:any): AxiosPromise<InformeHorasPorSubFuncion[]> {
		return this.cliente.post(filtro,`/HorasPorSubFuncion`);
	}

	ListarHorasPorDNSG(filtro:any): AxiosPromise<InformeHorasPorDNSG[]> {
		return this.cliente.post(filtro,`/HorasPorDNSG`);
	}

	ListarHorasPorProyecto(filtro:any): AxiosPromise<InformeHorasPorProyecto[]> {
		return this.cliente.post(filtro,`/HorasPorProyecto`);
	}

	ListarHorasPorPais(filtro:any): AxiosPromise<InformeHorasPorPais[]> {
		return this.cliente.post(filtro,`/HorasPorPais`);
	}

	ListarPersonasMasCincuentaPorc(filtro:any): AxiosPromise<InformePersonasMasCincuentaPorc[]> {
		return this.cliente.post(filtro,`/PersonasMasCincuentaPorc`);
	}

	ListarPersonasMenosCincuentaPorc(filtro:any): AxiosPromise<InformePersonasMenosCincuentaPorc[]> {
		return this.cliente.post(filtro,`/PersonasMenosCincuentaPorc`);
	}

	ListarHorasControlUtilidad(filtro:any): AxiosPromise<InformeHorasControlUtilidad[]> {
		return this.cliente.post(filtro,`/HorasControlUtilidad`);
	}

	ProvisionalDefinitivoExpatriados(anio:number): AxiosPromise<any[]> {
		return this.cliente.get(`/Expatriados/ProvisionalDefinitivo/${anio}`);
	}

	ProvisionalDefinitivoMesAnteriorExpatriados(anio:number): AxiosPromise<any[]> {
		return this.cliente.get(`/Expatriados/ProvisionalDefinitivoMesAnterior/${anio}`);
	}
}